import { render, staticRenderFns } from "./MidCategoryCarousel.vue?vue&type=template&id=e6d6487a&scoped=true&"
import script from "./MidCategoryCarousel.vue?vue&type=script&lang=js&"
export * from "./MidCategoryCarousel.vue?vue&type=script&lang=js&"
import style0 from "./MidCategoryCarousel.vue?vue&type=style&index=0&id=e6d6487a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d6487a",
  null
  
)

export default component.exports